<template>
  <div class="home">
    <header>
        <img alt="Vue logo" src="../assets/logo.svg">
    </header>
     <!-- <HelloWorld msg="Welcome to ElFasAdo"/> -->

    <div class="container"  v-bind:class="{ loaded }">
      <ul class="home-links">
        <router-link to="/visningar"><li><img src="../assets/icons/clock.svg"><span>visningar</span></li></router-link>
        <router-link to="/mina-budgivningar"><li><img src="../assets/icons/moneybox.svg"><span>budgivningar</span></li></router-link>
        <li class="not-yet-implemented"><img src="../assets/icons/globe.svg"><span>på internet<br> <span class="opaque-40 fs-12">kommer snart</span></span></li>
        <li class="not-yet-implemented"><img src="../assets/icons/forsale.svg"><span>sålda<br> <span class="opaque-40 fs-12">kommer snart</span></span></li>
        <li class="not-yet-implemented"><img src="../assets/icons/hetalista.svg"><span>Heta listan<br> <span class="opaque-40 fs-12">kommer snart</span></span></li>
        <li class="not-yet-implemented"><img src="../assets/icons/queue.svg"><span>Kö<br> <span class="opaque-40 fs-12">kommer snart</span></span></li>
        <li></li>
      </ul>
    </div>
    <Footer/>
  </div>
</template>

<script>

import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  data() {
    return {
      loaded: false
    }
  },
  components: {
    Footer
  },
  created() {
    this.$root.callFasAdApi("/internalapi/auth/test-login")
    .then((data) => {
      if (data.data.firstname) {
        // Note: default is email
        this.$store.commit('SET_AUTHENTICATED', data.data.firstname + " " + data.data.lastname);
        this.$store.commit('SET_AUTHENTICATED_USER_INFO', data.data);
      }
    }).catch(console.error);

    setTimeout(() => {
      this.loaded = true;
    }, 200)

  }
}
</script>

<style>
.home .container {
  transition: padding 750ms, opacity 750ms;
}
.home .container:not(.loaded) {
  padding-top: 50px;
  opacity: 0;
}
.home {
  padding-bottom: 100px;
}
header {
  height: 160px;
  background-color: var(--fasad-orange);
  padding: 15px;
}
.home-links {
  margin-top: -40px;
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 15px;
}
.home-links li {
  box-shadow: var(--home-links-shadow);
  height: 130px;
  background-color: white;
  padding: 15px;
  text-transform: uppercase;
  display: flex;
  align-items: flex-end;
  position: relative;
}
.home .home-links li:last-child {
  grid-column: 1 / 3;
}
.home-links li img {
  position: absolute;
  top: 15px;
  left: 15px;
}
.home-links .not-yet-implemented {
  background-color: var(--fasad-grey-2);
}
.home-links .not-yet-implemented * {
  opacity: .65;
}
a {
  text-decoration: none;
  color: black;
}
input {
  padding: 15px;
  border: 1px solid var(--fasad-grey-4);
}
</style>
